import { TGenericWrapperContext } from "cakemail-ui-components-v2"

/**
 * Choose proper text to display
 * @param genericWrapperContext - The generic Wrapper context.
 * @param locize - Locize string to check if in brand
 * @returns -Return the proper text to display for particular brand.
 */
export function overrideTextIfInBrand(genericWrapperContext: TGenericWrapperContext | undefined, locize: string): string {
    if (genericWrapperContext?.partnerBrand?.config?.text_override?.[locize]) {
        return genericWrapperContext?.partnerBrand?.config?.text_override[locize]
    }
    return locize
}
